import { useMemo } from 'react';

import type { ReportConfigAllocationCombination } from 'src/types/reportConfig';
import { DEFAULT_REPORT_CONFIG_COMBINATIONS } from 'src/components/reportConfig/constants';

const useReportConfigCombinations = (
  reportConfigData: ReportConfigAllocationCombination | undefined,
) => {
  const reportConfigCombinations = useMemo(
    () =>
      reportConfigData?.reportConfigCombinations?.content ||
      DEFAULT_REPORT_CONFIG_COMBINATIONS,
    [reportConfigData],
  );

  const configuredReportTypes = useMemo(
    () =>
      Object.entries(reportConfigCombinations.reportTypes).map(
        ([code, namesPerFileType]) => {
          // sort to ensure a consistent report type name
          const reportTypeNames = Object.values(namesPerFileType)
            .map(({ name }) => name)
            .sort((a, b) => Number(a) - Number(b));
          return {
            code: Number(code),
            name: reportTypeNames[0] ?? code,
          };
        },
      ),
    [reportConfigCombinations],
  );

  const configuredFileTypes = useMemo(
    () =>
      Object.entries(reportConfigCombinations.fileTypes).map(
        ([code, info]) => ({
          code: Number(code),
          abbreviation: info.abbreviation,
        }),
      ),
    [reportConfigCombinations],
  );

  return { configuredReportTypes, configuredFileTypes };
};

export default useReportConfigCombinations;
